const customPages = {
  'SDP':'privatization',
  'PJP':'sales',
  'JRBS':'financed'
}

export default function(router, program) {
  let customPage = customPages[program.PROGRAM_CODE]
  if (customPage) {
    router.push({name: customPage})
  } else {
    router.push({ name: 'program', params: {
      programId: program.ID,
      docId: program.DOCUMENT_ID
    } })
  }
  
}